import {ICON_TYPES} from '../constants';

export const EyeIcon = () => {
  return (
    <svg
      width='14'
      height='11'
      viewBox='0 0 14 11'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M13.8955 5.02225C13.3833 3.90225 11.3749 0.25 6.99993 0.25C2.62493 0.25 0.616508 3.90225 0.104342 5.02225C0.0355889 5.17234 0 5.33549 0 5.50058C0 5.66567 0.0355889 5.82882 0.104342 5.97892C0.616508 7.09775 2.62493 10.75 6.99993 10.75C11.3749 10.75 13.3833 7.09775 13.8955 5.97775C13.9641 5.82783 13.9996 5.66488 13.9996 5.5C13.9996 5.33512 13.9641 5.17217 13.8955 5.02225V5.02225ZM6.99993 9.58333C3.32084 9.58333 1.60409 6.45317 1.16659 5.50642C1.60409 4.54683 3.32084 1.41667 6.99993 1.41667C10.6703 1.41667 12.3876 4.53342 12.8333 5.5C12.3876 6.46658 10.6703 9.58333 6.99993 9.58333Z'
        fill='#43494F'
      />
      <path
        d='M6.99992 2.5835C6.42306 2.5835 5.85915 2.75456 5.37951 3.07504C4.89986 3.39553 4.52603 3.85105 4.30527 4.384C4.08452 4.91695 4.02676 5.5034 4.1393 6.06918C4.25184 6.63495 4.52962 7.15466 4.93753 7.56256C5.34543 7.97046 5.86513 8.24825 6.43091 8.36079C6.99668 8.47333 7.58313 8.41557 8.11608 8.19481C8.64903 7.97406 9.10455 7.60022 9.42504 7.12058C9.74553 6.64093 9.91659 6.07703 9.91659 5.50016C9.91566 4.7269 9.60807 3.98557 9.06129 3.43879C8.51451 2.89201 7.77318 2.58442 6.99992 2.5835V2.5835ZM6.99992 7.25016C6.6538 7.25016 6.31546 7.14753 6.02767 6.95524C5.73989 6.76294 5.51558 6.48963 5.38313 6.16986C5.25068 5.85009 5.21602 5.49822 5.28355 5.15876C5.35107 4.81929 5.51774 4.50747 5.76248 4.26273C6.00722 4.01798 6.31905 3.85131 6.65851 3.78379C6.99798 3.71626 7.34985 3.75092 7.66962 3.88337C7.98939 4.01583 8.2627 4.24013 8.45499 4.52792C8.64728 4.8157 8.74992 5.15405 8.74992 5.50016C8.74992 5.96429 8.56555 6.40941 8.23736 6.7376C7.90917 7.06579 7.46405 7.25016 6.99992 7.25016Z'
        fill='#43494F'
      />
    </svg>
  );
};

EyeIcon.iconType = ICON_TYPES.EYE;
